namespace Nobox {
    export namespace PermissionKeys {
        export const MasterData = "Administration:MasterData";
        export const General = "";

        namespace Accountings {
            export const Delete = "Accountings:Delete";
            export const Modify = "Accountings:Modify";
            export const View = "Accountings:View";
        }

        namespace Log {
            export const Delete = "Log:Delete";
            export const Modify = "Log:Modify";
            export const View = "Log:View";
        }

        namespace Tasks {
            export const Delete = "Tasks:Delete";
            export const Modify = "Tasks:Modify";
            export const View = "Tasks:View";
        }

        namespace Form {
            export const Delete = "Form:Delete";
            export const Modify = "Form:Modify";
            export const View = "Form:View";
        }

        namespace Deals {
            export const Delete = "Deals:Delete";
            export const Modify = "Deals:Modify";
            export const View = "Deals:View";
        }

        namespace TasksBoard {
            export const Delete = "TasksBoard:Delete";
            export const Modify = "TasksBoard:Modify";
            export const View = "TasksBoard:View";
        }

        namespace Group {
            export const Delete = "Group:Delete";
            export const Modify = "Group:Modify";
            export const View = "Group:View";
        }

        namespace Expenses {
            export const Delete = "Expenses:Delete";
            export const Modify = "Expenses:Modify";
            export const View = "Expenses:View";
        }

        namespace ExpensesCategory {
            export const Delete = "Expensecategory:Delete";
            export const Modify = "Expensecategory:Modify";
            export const View = "Expensecategory:View";
        }

        namespace PaymentMethods {
            export const Delete = "Payments:Delete";
            export const Modify = "Payments:Modify";
            export const View = "Payments:View";
        }

        namespace Product {
            export const Delete = "Product:Delete";
            export const Modify = "Product:Modify";
            export const View = "Product:View";
        }

        namespace ProductTags {
            export const Delete = "ProductTags:Delete";
            export const Modify = "ProductTags:Modify";
            export const View = "ProductTags:View";
        }

        namespace TasksCategory {
            export const Delete = "TasksCategory:Delete";
            export const Modify = "TasksCategory:Modify";
            export const View = "TasksCategory:View";
        }

        namespace Accounts {
            export const Delete = "Accounts:Delete";
            export const Modify = "Accounts:Modify";
            export const View = "Accounts:View";
        }

        namespace Contact {
            export const Delete = "Contact:Delete";
            export const Modify = "Contact:Modify";
            export const View = "Contact:View";
        }

        namespace ContactTags {
            export const Delete = "ContactTags:Delete";
            export const Modify = "ContactTags:Modify";
            export const View = "ContactTags:View";
        }

        namespace List {
            export const Delete = "List:Delete";
            export const Modify = "List:Modify";
            export const View = "List:View";
        }

        namespace Campaign {
            export const Delete = "Campaign:Delete";
            export const Modify = "Campaign:Modify";
            export const View = "Campaign:View";
        }

        namespace CampaignTags {
            export const Delete = "CampaignTags:Delete";
            export const Modify = "CampaignTags:Modify";
            export const View = "CampaignTags:View";
        }

        namespace CampaignResult {
            export const Delete = "Campaign Result:Delete";
            export const Modify = "Campaign Result:Modify";
            export const View = "Campaign Result:View";
        }

        namespace CampaignTemplate {
            export const Delete = "CampaignTemplate:Delete";
            export const Modify = "CampaignTemplate:Modify";
            export const View = "CampaignTemplate:View";
        }

        namespace PluginSettings {
            export const Delete = "PluginSettings:Delete";
            export const Modify = "PluginSettings:Modify";
            export const View = "PluginSettings:View";
        }

        namespace PluginSessions {
            export const Delete = "PluginSessions:Delete";
            export const Modify = "PluginSessions:Modify";
            export const View = "PluginSessions:View";
        }

        namespace EmailQueuePerTenant {
            export const Delete = "EmailQueuePerTenant:Delete";
            export const Modify = "EmailQueuePerTenant:Modify";
            export const View = "EmailQueuePerTenant:View";
        }

        namespace EmailQueueAdmin {
            export const Delete = "EmailQueueAdmin:Delete";
            export const Modify = "EmailQueueAdmin:Modify";
            export const View = "EmailQueueAdmin:View";
        }

        namespace Master {
            export const Delete = "Master:Delete";
            export const Modify = "Master:Modify";
            export const View = "Master:View";
        }

        namespace Tenant {
            export const Owner = "Nobox:Owner";
            export const Manager = "Nobox:Manager";
            export const Member = "Nobox:Member";
        }

        namespace CompanyProfile {
            export const CompanyProfile1 = "Nobox:CompanyProfile";
        }
    }
}
